/**
 * Utility functions for date formatting.
 * Extracted for reusability and performance (avoid repeated object creation).
 */

/**
 * Convert ISO datetime string to YYYY-MM-DD format.
 * @param dateString ISO datetime string (e.g., "2026-10-22T14:30:00Z")
 * @returns Formatted date string (e.g., "2026-10-22")
 */
export const formatDateAsYYYYMMDD = (dateString: string | null | undefined): string | null => {
  if (!dateString) {
    return null;
  }
  try {
    return dateString.split('T')[0];
  } catch {
    return null;
  }
};

/**
 * Get display text for status update with creator/updater info.
 * Handles both created and updated cases with proper null checks.
 */
export const getStatusUpdateAuthorText = (
  createdBy: string | null | undefined,
  createdAt: string | null | undefined,
  updatedBy: string | null | undefined,
  updatedAt: string | null | undefined,
): string => {
  // If updated: show latest editor
  if (updatedBy && updatedAt) {
    const formattedDate = formatDateAsYYYYMMDD(updatedAt);
    return `updated by ${updatedBy} on ${formattedDate}`;
  }

  // If not updated: show creator
  if (createdBy && createdAt) {
    const formattedDate = formatDateAsYYYYMMDD(createdAt);
    return `created by ${createdBy} on ${formattedDate}`;
  }

  // Fallback: just creator email
  return createdBy || 'Unknown';
};
